var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignTalentCreatorsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "videography",
    transform: "translate(-2 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36412",
    "data-name": "Path 36412",
    d: "M44.494,22.881a2.968,2.968,0,0,0-3.006.01L36,26.093V36.908l5.488,3.2A3,3,0,0,0,46,37.52V25.484a2.968,2.968,0,0,0-1.506-2.6Z",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36413",
    "data-name": "Path 36413",
    d: "M30.6,21.287A8.5,8.5,0,1,0,20.028,21H14.587a7.5,7.5,0,1,0-9.638.452A5,5,0,0,0,2,26V37a5.006,5.006,0,0,0,5,5H29a5.006,5.006,0,0,0,5-5V26A4.99,4.99,0,0,0,30.6,21.287ZM6.5,15.5a3,3,0,1,1,3,3A3,3,0,0,1,6.5,15.5ZM12,37H8a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2ZM25.5,18.5a4,4,0,1,1,4-4A4,4,0,0,1,25.5,18.5Z",
    fill: "#ed1c24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignTalentCreatorsIcon);
export default __webpack_public_path__ + "static/media/Sign Talent & Creators_icon.b106fb2b758336719da34530e98c42d0.svg";
export { ForwardRef as ReactComponent };